var allRanges = document.querySelectorAll(".range-with-output");

allRanges.forEach(function (wrap) {
    var range = wrap.querySelector(".range");
    var bubble = wrap.querySelector(".bubble");

    range.addEventListener("input", function () {
        setBubble(range, bubble);
        updateRangeBackground(range);
    });

    setBubble(range, bubble);
    updateRangeBackground(range);
});

function setBubble(range, bubble) {
    var val = range.value,
        min = range.min ? range.min : 0,
        max = range.max ? range.max : 100,
        format = range.dataset.format,
        template = range.dataset.template,
        thousandsSeparator = range.dataset.thousands_separator ?? ' ',
        newVal = Number(((val - min) * 100) / (max - min));

    if (format === "1") {
        if (val < 1000) {
            //do nothing
        } else if (val < 1000000) {
            val = (val / 1000).toFixed(0) + "K";
        } else {
            val = (val / 1000000).toFixed(1) + "M";
        }
    } else {
        val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
    }

    bubble.innerHTML = template.replace("{{amount}}", val);

    // Sorta magic numbers based on size of the native UI thumb

    let bubbleLeftPosition = calculateAndGetBubbleArrowLeftPosition(newVal);
    document.documentElement.style.setProperty('--range-with-output-bubble-arrow-left-position', bubbleLeftPosition + '%');

    let initialPercentage = newVal;

    if (newVal > 90) {
        initialPercentage = 90;
    } else if (newVal < 10) {
        initialPercentage = 10;
    }

    bubble.setAttribute('data-newVal', newVal)

    bubble.style.left = 'calc(' + initialPercentage + '% + (' + (8 - newVal * 0.15) + 'px))';
}

function calculateAndGetBubbleArrowLeftPosition(newVal) {
    let bubbleLeftPosition = 50;
    const sidePercentage = calculateAndGetSidePercentage(newVal);

    if (sidePercentage === null) {
        return bubbleLeftPosition;
    }

    if (newVal >= 90) {
        const relativeMax = 35; // in range 50-85
        bubbleLeftPosition = relativeMax * (sidePercentage / 100) + 50;
    } else if (newVal <= 10) {
        const relativeMax = 35; // in range 15-50
        bubbleLeftPosition = relativeMax * (sidePercentage / 100) + 15;
    }

    return bubbleLeftPosition;
}

function calculateAndGetSidePercentage(newVal) {
    let sidePercentage = null;

    // formula: (currentValue - min) / relativeMax * 100
    // relativeMax = 100-90 or 10-0

    if (newVal >= 90) {
        // min here is 90
        sidePercentage = (newVal - 90) / 10 * 100;
    } else if (newVal <= 10) {
        // min here is 0
        sidePercentage = (newVal - 0) / 10 * 100;
    }

    return sidePercentage;
}

function updateRangeBackground(range) {
    const c1 = range.dataset.c1 || getComputedStyle(range).getPropertyValue('--range-c1').trim();
    const c2 = range.dataset.c2 || getComputedStyle(range).getPropertyValue('--range-c2').trim();
    const c3 = range.dataset.c3 || getComputedStyle(range).getPropertyValue('--range-c3').trim();

    if (!c1 || !c2 || !c3) {
        return;
    }

    const min = range.min ? Number(range.min) : 0;
    const max = range.max ? Number(range.max) : 100;
    const val = Number(range.value);
    const pct = ((val - min) * 100) / (max - min);

    range.style.background = `linear-gradient(to right, ${c1} 0%, ${c2} ${pct}%, ${c3} ${pct}%)`;
}
